import React, { Component, PropTypes } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { Tabs, Tab } from 'material-ui/Tabs';
import * as request from 'superagent';
import FileUploadIcon from 'material-ui/svg-icons/file/file-upload';
import CircularProgress from 'material-ui/CircularProgress';
import AddIcon from 'material-ui/svg-icons/content/add';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { TableRow, TableRowColumn } from "material-ui/Table";
import _ from 'lodash';

import * as DataAPI from "../../../common/DataAPI.js";
import Dialogs from "../../../common/Dialogs.js";
import constants from "../../../common/constants";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";

const styles = {
  slideContainer: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    height: '85%',
  }
};

class UserDialog extends Component {
  constructor(props) {
    super();
    this.state = {
      user: {},
      roles: [],
    };

    // this.submitPhoto = this.submitPhoto.bind(this);
    this.updateUserState = this.updateUserState.bind(this);
    this.handleInsert = this.handleInsert.bind(this);
    this.handleClose = this.handleClose.bind(this);
    // this.openPhotoDialog = this.openPhotoDialog.bind(this);
    // this.closePhotoDialog = this.closePhotoDialog.bind(this);
    // this.removePhoto = this.removePhoto.bind(this);
  }

  componentWillMount() {

  }

  componentWillReceiveProps(newProps) {
    if (!_.isEqual(newProps.user, this.state.user)) {
      this.setState({
        user: newProps.user,
      });
    }

    if (!_.isEqual(newProps.roles, this.state.roles)) {
      this.setState({
        roles: newProps.roles,
      });
    }
  }

  // removePhoto() {
  //   let user = _.cloneDeep(this.state.user);
  //
  //   user.photo = '';
  //
  //   this.setState({
  //     user,
  //   });
  // }

  // openPhotoDialog() {
  //   this.setState({
  //     shouldOpenPhotosDialog: true,
  //   });
  // }

  // closePhotoDialog() {
  //   this.setState({
  //     shouldOpenPhotosDialog: false,
  //   });
  // }

  handleInsert() {
    this.props.handleSubmit(this.state.user);
  }

  handleClose() {
    this.props.handleClose();
  }

  // submitPhoto(photos) {
  //   this.updateUserState('photo', _.head(photos));
  //   this.closePhotoDialog();
  // }

  updateUserState(field, value) {
    let user = _.cloneDeep(this.state.user);

    _.set(user, field, value);

    this.setState({
      user,
    });
  }


  render() {
    let actions = [];

    actions.push(<FlatButton
      label="取消"
      primary={true}
      onClick={this.handleClose}
    />);

    actions.push(
      <FlatButton
        label="儲存"
        primary={true}
        onClick={this.handleInsert}
      />
    );


    const wrapOnChange = (fnc, field, event, value) => {
      fnc(field, value);
    };

    const wrapSelecFieldtOnChange = (fnc, field, event, index, value) => {
      fnc(field, value);
    };

    return (
      <div>
        <Dialog
          title="用戶"
          actions={actions}
          modal={false}
          open={this.props.open}
          autoScrollBodyContent={true}
          // autoDetectWindowHeight={false}
          bodyClassName="user-dialog"
          // actionsContainerClassName="user-actions-block"
        >
          <div>
            {/*{*/}
            {/*_.get(this.state.user, 'photo.url') &&*/}
            {/*<div><img src={this.state.user.photo.url} style={{*/}
            {/*height: 100,*/}
            {/*marginTop: 10,*/}
            {/*}} /></div>*/}
            {/*}*/}
            {/*<FlatButton*/}
            {/*label="選擇相片"*/}
            {/*primary={true}*/}
            {/*icon={<AddIcon />}*/}
            {/*style={{*/}
            {/*marginTop: 10,*/}
            {/*}}*/}
            {/*onClick={this.openPhotoDialog.bind(this)} />*/}
            {/*<FlatButton*/}
            {/*label="刪除相片"*/}
            {/*secondary={true}*/}
            {/*style={{*/}
            {/*marginTop: 10,*/}
            {/*}}*/}
            {/*onClick={this.removePhoto.bind(this)} />*/}

            <TextField
              floatingLabelText="ID"
              name="loginId"
              value={_.get(this.state.user, 'loginId')}
              onChange={wrapOnChange.bind(this, this.updateUserState, 'loginId')}
              fullWidth={true}
              type="text"
            />
            <TextField
              floatingLabelText="密碼"
              name="password"
              value={_.get(this.state.user, 'password', '')}
              onChange={wrapOnChange.bind(this, this.updateUserState, 'password')}
              fullWidth={true}
              type="password"
            />
            <TextField
              floatingLabelText="名稱"
              name="name"
              value={_.get(this.state.user, 'name', '')}
              onChange={wrapOnChange.bind(this, this.updateUserState, 'name')}
              fullWidth={true}
              type="text"
            />

            <div className="label-text" style={{
              marginTop: 10,
            }}>類型
            </div>
            <RadioButtonGroup
              name="role"
              valueSelected={_.get(this.state.user, 'role')}
              style={styles.radioButtonGroup}
              onChange={wrapOnChange.bind(this, this.updateUserState, 'role')}>
              {
                _.map(this.state.roles, (role, index) => (
                  <RadioButton
                    key={index}
                    value={role._id}
                    label={role.name}
                    style={styles.radioButton}
                  />
                ))
              }
            </RadioButtonGroup>

            <div className="label-text" style={{
              marginTop: 10,
            }}>狀態
            </div>
            <RadioButtonGroup
              name="status"
              defaultSelected="active"
              valueSelected={_.get(this.state.user, 'status')}
              style={styles.radioButtonGroup}
              onChange={wrapOnChange.bind(this, this.updateUserState, 'status')}>
              <RadioButton
                value="active"
                label="啟用"
                style={styles.radioButton}
              />
              <RadioButton
                value="inactive"
                label="停用"
                style={styles.radioButton}
              />
            </RadioButtonGroup>
          </div>
        </Dialog>
        {/*<PhotosDialog*/}
        {/*open={this.state.shouldOpenPhotosDialog}*/}
        {/*maxNoOfPhotosSelectable={1}*/}
        {/*maxNoOfPhotosUploadable={constants.maxNoOfPhotosUploadable}*/}
        {/*handleClose={this.closePhotoDialog}*/}
        {/*handleSubmit={this.submitPhoto.bind(this)} />*/}
        {/*<Dialogs onInit={dialog => (this.dialogs = dialog)} />*/}
      </div>
    )
  }
}

UserDialog.propTypes = {
  open: PropTypes.bool,
  user: PropTypes.object,
  roles: PropTypes.array,
  handleSubmit: PropTypes.func,
  handleClose: PropTypes.func,
};

UserDialog.defaultProps = {
  open: false,
  user: {},
  roles: [],
  handleSubmit: () => {
  },
  handleClose: () => {
  },
};

export default UserDialog;


// WEBPACK FOOTER //
// client/adminPanel/panel/users/UserDialog.js